import request from '@/utils/request'

export function getVipInfo () {
    return request({
      url: '/api/enterprise/employmentMember/enterpriseMemberController/queryByUserId',
      method: 'post',
    })
  }